import { render } from "./AllSegmentGroupsClientsByRegion.vue?vue&type=template&id=d929c07e&scoped=true"
import script from "./AllSegmentGroupsClientsByRegion.vue?vue&type=script&lang=js"
export * from "./AllSegmentGroupsClientsByRegion.vue?vue&type=script&lang=js"

import "./AllSegmentGroupsClientsByRegion.vue?vue&type=style&index=0&id=d929c07e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d929c07e"]])

export default __exports__